define ['./home.css'], () ->
  ($scope, $state, RentappService, $stateParams, hotkeys) ->
    console.log "home"
    hotkeys.bindTo($scope)
    .add
      combo: 'd',
      description: 'Dashboard'
      callback: () -> $state.go "root.dashboard"

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
      if toState.resolve
        $scope.show_spinner = true
    )
    
    $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
      if toState.resolve
        $scope.show_spinner = false
    )



// WEBPACK FOOTER //
// ./components/home/home.coffee